import { Link } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { ProductCard } from "@/components/ProductCard";

export default function Favorites() {
  const { favorites } = useStore();
  return (
    <div className="max-w-[1440px] mx-auto px-5 sm:px-8 pt-12" data-testid="favorites-page">
      <div className="text-[11px] uppercase tracking-[0.25em] text-[#956842] mb-3">I tuoi</div>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#39251D] mb-12">Preferiti</h1>
      {favorites.length === 0 ? (
        <div className="py-16 text-center" data-testid="favorites-empty">
          <p className="font-serif text-2xl text-[#39251D]/70">Non hai ancora salvato nessun prodotto.</p>
          <Link to="/collezione" data-testid="favorites-browse-link" className="inline-block mt-6 text-xs uppercase tracking-[0.2em] border-b border-[#956842] pb-1">Scopri la collezione</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-12 sm:gap-x-6">
          {favorites.map((p) => <ProductCard key={p.slug} p={p} />)}
        </div>
      )}
    </div>
  );
}
